import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { galleryItems, galleryCategories } from '../../mocks/gallery';

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<null | { image: string; title: string; destination: string }>(null);

  const filtered = galleryItems.filter(
    (item) => activeCategory === 'All' || item.category === activeCategory
  );

  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="relative h-72 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/9d9ebaa99c6aa0604ce0f1366df4aa9e.jpg"
          alt="Gallery"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-emerald-900/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pt-20">
          <p className="text-amber-400 text-sm font-semibold uppercase tracking-widest mb-3">Through Our Lens</p>
          <h1 className="text-4xl md:text-5xl font-bold text-white font-playfair">Travel Gallery</h1>
          <p className="text-white/75 mt-3 text-base max-w-xl">
            A visual journey through the world's most breathtaking destinations we have explored together.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="bg-white border-b border-gray-100 sticky top-20 z-30">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-wrap gap-2">
          {galleryCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-emerald-700 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {filtered.map((item) => (
              <div
                key={item.id}
                className="group relative break-inside-avoid rounded-xl overflow-hidden cursor-pointer"
                onClick={() => setLightbox({ image: item.image, title: item.title, destination: item.destination })}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <p className="text-white font-bold text-sm font-playfair">{item.title}</p>
                  <p className="text-white/75 text-xs mt-1">
                    <i className="ri-map-pin-line mr-1"></i>{item.destination}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-4xl w-full max-h-[90vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setLightbox(null)}
              className="absolute -top-10 right-0 text-white/70 hover:text-white cursor-pointer w-8 h-8 flex items-center justify-center"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <img
              src={lightbox.image}
              alt={lightbox.title}
              className="max-h-[80vh] w-auto max-w-full rounded-lg object-contain"
            />
            <div className="mt-4 text-center">
              <p className="text-white font-bold text-lg font-playfair">{lightbox.title}</p>
              <p className="text-white/65 text-sm mt-1">
                <i className="ri-map-pin-line mr-1"></i>{lightbox.destination}
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
